// extracted by mini-css-extract-plugin
module.exports = {"richTextWrapper":"RichText-module--richTextWrapper--DkBDQ","row":"RichText-module--row--1wDow"};